import { render, staticRenderFns } from "./Suburbs.vue?vue&type=template&id=768403cc&scoped=true"
import script from "./Suburbs.vue?vue&type=script&lang=ts"
export * from "./Suburbs.vue?vue&type=script&lang=ts"
import style0 from "./Suburbs.scss?vue&type=style&index=0&id=768403cc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768403cc",
  null
  
)

export default component.exports